import { render, staticRenderFns } from "./MArticleDetail.vue?vue&type=template&id=0ed5769b&scoped=true"
import script from "./MArticleDetail.vue?vue&type=script&lang=js"
export * from "./MArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./MArticleDetail.vue?vue&type=style&index=0&id=0ed5769b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5769b",
  null
  
)

export default component.exports